import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, OnChanges, SimpleChanges } from '@angular/core'
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-select-web',
  templateUrl: './select-web.component.html',
  styleUrls: ['./select-web.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, FormsModule, TranslateModule]
})
export class SelectWebComponent implements OnInit, OnChanges {
  constructor() {}

  @Input() input: any = {
    label: 'Filtro',
    placeholder: 'Seleccionar',
    type: 'select',
    options: [
      { label: 'Todos', value: '' },
      { label: 'Opción 1', value: '1' },
      { label: 'Opción 2', value: '2' },
      { label: 'Opción 3', value: '3' }
    ]
  }

  @Input() disabled: boolean = false
  @Input() value: any = null; // valor inicial desde el padre
  @Output() valueChange = new EventEmitter<any>();

  selectedOption: string | null = null

  @ViewChild('selectElement', { static: false }) selectElement!: ElementRef

  openSelect() {
    if (this.selectElement) {
      this.selectElement.nativeElement.focus()
    }
  }

  onChange(event: any) {
    const val = event.target.value;
    this.selectedOption = val;
    this.valueChange.emit(val);
  }

  ngOnInit() {
    if (this.value !== undefined && this.value !== null) {
      this.selectedOption = this.value;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['value'] && !changes['value'].firstChange) {
      this.selectedOption = changes['value'].currentValue;
    }
  }
}
